/*
 * @Description: Description
 * @Author: Dai Guo
 * @Date: 2022-04-28 09:48:45
 * @LastEditors: guorui.teng 704386484@qq.com
 * @LastEditTime: 2023-03-13 16:35:16
 */
import { getLengthP2XTopPanelInfo, getLengthXTopPanelInfo } from '../../heightSinkCabinet/renderHSinkCabinet';
import LengthP2X from '../../lengthTypes/lengthP2X';
import LengthX from '../../lengthTypes/lengthX';
import MeshManage from '../../meshManage';
import SkirtingBoard from '../../specialHandler/skirtingBoard';
import TopPanel from '../../specialHandler/topPanel';
import { AXES_ENUM, BASICTYPE_ENUM, LengthLocation, LengthType, } from '../../utils/enum';
import { FRAMEDEPTH, SKIRTINGBOARDCONFIG, TOPPANELCONFIG, } from '../../utils/kitchenConfig';
import { checkHasHightFrameByPosition } from '../../utils/renderUtils';
import { getFramePositionInfo } from '../../utils/templatejsonUtils';
function hightFrameHole(renderHThis, options) {
    var _a, _b, _c, _d;
    const { position, size, sidePlateDepth, position2, size2, sidePlateDepth3, topPanel2, topPanel, topPanelTexture, } = options;
    // 如果有高柜，高柜位置挖洞
    if (renderHThis.highFrameMesh) {
        let length = LengthType.Length1;
        let tempPositon = position;
        let tempSize = size;
        let tempSidePlateDepth = sidePlateDepth;
        if (renderHThis.highFrameMeshLocation === 2) {
            // 如果高柜在L3边
            length = LengthType.Length3;
            tempPositon = position2;
            tempSize = size2;
            tempSidePlateDepth = sidePlateDepth3;
        }
        // 将多个高柜作为一个整体获取中心坐标和尺寸
        const highFrameData = renderHThis.getHighFrameGroupPositionAndSize(BASICTYPE_ENUM.bottom, length);
        const holePosition = {
            x: renderHThis.templateJson.version > '2.2'
                ? (_a = highFrameData === null || highFrameData === void 0 ? void 0 : highFrameData.position) === null || _a === void 0 ? void 0 : _a.x : ((_b = highFrameData === null || highFrameData === void 0 ? void 0 : highFrameData.position) === null || _b === void 0 ? void 0 : _b.x) - TOPPANELCONFIG.DEPTH / 2,
            y: tempPositon.y,
            z: tempPositon.z + TOPPANELCONFIG.DEPTH / 2,
        };
        const holeSize = {
            width: renderHThis.templateJson.version > '2.2'
                ? ((_c = highFrameData === null || highFrameData === void 0 ? void 0 : highFrameData.size) === null || _c === void 0 ? void 0 : _c.x) + tempSidePlateDepth * 2 : ((_d = highFrameData === null || highFrameData === void 0 ? void 0 : highFrameData.size) === null || _d === void 0 ? void 0 : _d.x) + TOPPANELCONFIG.DEPTH,
            height: TOPPANELCONFIG.HEIGHT,
            depth: tempSize.depth + TOPPANELCONFIG.DEPTH,
        };
        if (renderHThis.highFrameMeshLocation === 2) {
            topPanel2.createHoleTopPanel(holePosition, holeSize, topPanelTexture);
        }
        else {
            topPanel === null || topPanel === void 0 ? void 0 : topPanel.createHoleTopPanel(holePosition, holeSize, topPanelTexture);
        }
    }
}
function sinkHole(renderHThis, options) {
    const { topPanel, topPanel2, topPanelTexture, } = options;
    const sinkPositionInfo = Object.assign({}, getFramePositionInfo(renderHThis === null || renderHThis === void 0 ? void 0 : renderHThis.templateJson, 'sink'));
    let holePositionY = 0;
    // 如果水槽存在
    if (sinkPositionInfo.id) {
        let lx = null;
        let tmpTopPanel = null;
        if (sinkPositionInfo.location === 1) {
            lx = new LengthX(renderHThis.templateJson, renderHThis.scene, LengthLocation.Bottom, LengthType.Length1);
            tmpTopPanel = topPanel;
        }
        else {
            lx = new LengthP2X(renderHThis.templateJson, renderHThis.scene, LengthLocation.Bottom, LengthType.Length3);
            tmpTopPanel = topPanel2;
        }
        holePositionY = tmpTopPanel.position.y;
        const cornerCabinetDirection = '';
        const { holePosition, holeSize } = lx.getSinkHolePosition(sinkPositionInfo.cabinetId, sinkPositionInfo.id, holePositionY, cornerCabinetDirection, sinkPositionInfo.frameInfo);
        lx.createHole(holePosition, holeSize, topPanelTexture, tmpTopPanel, sinkPositionInfo.frameInfo.componentBasic.componentId);
    }
    // eslint-disable-next-line no-param-reassign
    renderHThis.XNeddHideMesh = [...renderHThis.XNeddHideMesh, topPanel === null || topPanel === void 0 ? void 0 : topPanel.mesh];
    // eslint-disable-next-line no-param-reassign
    renderHThis.P2XNeddHideMesh = [...renderHThis.P2XNeddHideMesh, topPanel2 === null || topPanel2 === void 0 ? void 0 : topPanel2.mesh];
}
function renderTopPanelUtils(renderHThis) {
    var _a, _b, _c, _d, _e, _f;
    const { bottom } = renderHThis === null || renderHThis === void 0 ? void 0 : renderHThis.templateJson;
    const { length1, length3 } = bottom;
    const topPanelTexture = (_a = bottom === null || bottom === void 0 ? void 0 : bottom.topPanels[0].componentBasic) === null || _a === void 0 ? void 0 : _a.modelUrl;
    // 获取水槽排列位置
    const sinkPositionInfo = Object.assign({}, getFramePositionInfo(renderHThis === null || renderHThis === void 0 ? void 0 : renderHThis.templateJson, 'sink'));
    // 获取灶台位置
    const stovePositionInfo = Object.assign({}, getFramePositionInfo(renderHThis === null || renderHThis === void 0 ? void 0 : renderHThis.templateJson, 'stove'));
    const lastFrame = length1 === null || length1 === void 0 ? void 0 : length1.frames[(length1 === null || length1 === void 0 ? void 0 : length1.frames.length) - 1];
    const mesh = renderHThis.scene.getMeshByName((_b = lastFrame === null || lastFrame === void 0 ? void 0 : lastFrame.componentBasic) === null || _b === void 0 ? void 0 : _b.id);
    // 二字型特殊处理 顶部只有高柜 底部没有柜体只有补板的情况
    const checkLengthXBottomNoFrames = LengthX.checkTopNoFrames(renderHThis.templateJson, BASICTYPE_ENUM.bottom);
    const checkLengthP2XBoootomNoFrames = LengthP2X.checkTopNoFrames(renderHThis.templateJson, BASICTYPE_ENUM.bottom);
    let topPanel = null;
    // version 2.3 add by xiaohua.zhu 20220330 侧板对象结构有调整 需要判断版本
    let sidePlateDepth = renderHThis.getSidePlateDepth('length1');
    if (mesh && !checkLengthXBottomNoFrames) {
        // 当顶柜有高柜，底柜和高柜需要补板填补空隙(比如底柜240顶柜307)
        let sealPlateSizeX = 0;
        if (renderHThis.isSealPlateBeforeTopHightFrame(LengthType.Length1)
            || renderHThis.isSealPlateBeforeTopRefrigeraror(LengthType.Length1)) {
            sealPlateSizeX = renderHThis.getSealPlateSize(BASICTYPE_ENUM.bottom, LengthType.Length1, AXES_ENUM.x);
        }
        else {
            sealPlateSizeX = renderHThis.getSealPlateSizeOnlyOneFrame(BASICTYPE_ENUM.bottom, LengthType.Length1, AXES_ENUM.x);
        }
        // 检查顶柜里是否有高柜
        if (checkHasHightFrameByPosition(renderHThis.templateJson, BASICTYPE_ENUM.top, LengthType.Length1)) {
            if (!renderHThis.checkTopHightFrameIsSeparated(LengthType.Length1)) {
                // 当顶柜有高柜，底柜和高柜之间相连，高柜侧板与底柜最后一个柜子重叠在一起，此时台面需要减去侧板厚度
                sidePlateDepth = -sidePlateDepth;
            }
        }
        // const bounds = mesh.getHierarchyBoundingVectors();
        const lastMeshManage = new MeshManage(mesh);
        const lengthXConfigs = lastMeshManage.getLengthXConfigs(sidePlateDepth + sealPlateSizeX);
        const l1TopPanelArr = [];
        const l1TopPanelInfoArr = getLengthXTopPanelInfo(renderHThis, lengthXConfigs, sinkPositionInfo.location, stovePositionInfo.location);
        l1TopPanelInfoArr.forEach((item) => {
            const tempTopPanel = new TopPanel(renderHThis.scene, item.position, item.size, true);
            tempTopPanel.createTopPanel(topPanelTexture);
            l1TopPanelArr.push(tempTopPanel);
        });
        const l1LastTopPanel = l1TopPanelArr[l1TopPanelArr.length - 1];
        topPanel = l1LastTopPanel;
        if (sinkPositionInfo.id) {
            let lx = null;
            const lastFrame2 = length3 === null || length3 === void 0 ? void 0 : length3.frames[((_c = length3 === null || length3 === void 0 ? void 0 : length3.frames) === null || _c === void 0 ? void 0 : _c.length) - 1];
            const mesh2 = renderHThis.scene.getMeshByName((_d = lastFrame2 === null || lastFrame2 === void 0 ? void 0 : lastFrame2.componentBasic) === null || _d === void 0 ? void 0 : _d.id);
            if (!mesh2 || checkLengthP2XBoootomNoFrames) {
                if (sinkPositionInfo.location === 1) {
                    lx = new LengthX(renderHThis.templateJson, renderHThis.scene, LengthLocation.Bottom, LengthType.Length1);
                }
                else {
                    lx = new LengthP2X(renderHThis.templateJson, renderHThis.scene, LengthLocation.Bottom, LengthType.Length3);
                }
                const cornerCabinetDirection = '';
                const { holePosition, holeSize, } = lx.getSinkHolePosition(sinkPositionInfo.cabinetId, sinkPositionInfo.id, l1LastTopPanel.position.y, cornerCabinetDirection, sinkPositionInfo.frameInfo);
                lx.createHole(holePosition, holeSize, topPanelTexture, l1LastTopPanel, sinkPositionInfo.frameInfo.componentBasic.componentId);
            }
        }
        // eslint-disable-next-line no-param-reassign
        renderHThis.XNeddHideMesh = [...renderHThis.XNeddHideMesh];
        l1TopPanelArr.forEach((item) => {
            renderHThis.topPanelMesh.push(item.mesh);
            renderHThis.topPanelObjs.push(item);
            renderHThis.XNeddHideMesh.push(item.mesh);
            renderHThis.addMesh(item.mesh);
        });
    }
    // L3
    const lastFrame2 = length3 === null || length3 === void 0 ? void 0 : length3.frames[((_e = length3 === null || length3 === void 0 ? void 0 : length3.frames) === null || _e === void 0 ? void 0 : _e.length) - 1];
    const mesh2 = renderHThis.scene.getMeshByName((_f = lastFrame2 === null || lastFrame2 === void 0 ? void 0 : lastFrame2.componentBasic) === null || _f === void 0 ? void 0 : _f.id);
    const lastMeshManage2 = new MeshManage(mesh2);
    if (!mesh2 || checkLengthP2XBoootomNoFrames) {
        return;
    }
    // version 2.3 add by xiaohua.zhu 20220330 侧板对象结构有调整 需要判断版本
    let sidePlateDepth3 = renderHThis.getSidePlateDepth('length3');
    // 当顶柜有高柜，底柜和高柜需要补板填补空隙(比如底柜240顶柜307)
    let sealPlateSizeX1 = 0;
    if (renderHThis.isSealPlateBeforeTopHightFrame(LengthType.Length3)
        || renderHThis.isSealPlateBeforeTopRefrigeraror(LengthType.Length3)) {
        sealPlateSizeX1 = renderHThis.getSealPlateSize(BASICTYPE_ENUM.bottom, LengthType.Length3, AXES_ENUM.x);
    }
    else {
        const hTypeLength3Rlength = length3 === null || length3 === void 0 ? void 0 : length3.rlength;
        if ((length3 === null || length3 === void 0 ? void 0 : length3.frames.length) === 1 && hTypeLength3Rlength > 0) {
            sealPlateSizeX1 = renderHThis.getSealPlateSize(BASICTYPE_ENUM.bottom, LengthType.Length3, AXES_ENUM.x);
        }
    }
    // 检查顶柜里是否有高柜
    if (checkHasHightFrameByPosition(renderHThis.templateJson, BASICTYPE_ENUM.top, LengthType.Length3)) {
        if (!renderHThis.checkTopHightFrameIsSeparated(LengthType.Length3)) {
            // 当顶柜有高柜，底柜和高柜之间相连，高柜侧板与底柜最后一个柜子重叠在一起，此时台面需要减去侧板厚度
            sidePlateDepth3 = -sidePlateDepth3;
        }
    }
    const lengthXConfigs2 = lastMeshManage2.getLengthXConfigs(sidePlateDepth3 + sealPlateSizeX1);
    const l3TopPanelArr = [];
    const l3TopPanelInfoArr = getLengthP2XTopPanelInfo(renderHThis, lengthXConfigs2, sinkPositionInfo.location, stovePositionInfo.location);
    l3TopPanelInfoArr.forEach((item) => {
        const tempTopPanel = new TopPanel(renderHThis.scene, item.position, item.size, true);
        tempTopPanel.createTopPanel(topPanelTexture);
        l3TopPanelArr.push(tempTopPanel);
    });
    const l3LastTopPanel = l3TopPanelArr[l3TopPanelArr.length - 1];
    hightFrameHole(renderHThis, {
        position: topPanel === null || topPanel === void 0 ? void 0 : topPanel.position,
        size: topPanel === null || topPanel === void 0 ? void 0 : topPanel.size,
        sidePlateDepth,
        position2: l3LastTopPanel.position,
        size2: l3LastTopPanel.size,
        sidePlateDepth3,
        topPanel2: l3LastTopPanel,
        topPanel,
        topPanelTexture,
    });
    sinkHole(renderHThis, {
        position: topPanel === null || topPanel === void 0 ? void 0 : topPanel.position,
        size: topPanel === null || topPanel === void 0 ? void 0 : topPanel.size,
        sidePlateDepth,
        position2: l3LastTopPanel.position,
        size2: l3LastTopPanel.size,
        sidePlateDepth3,
        topPanel2: l3LastTopPanel,
        topPanel,
        topPanelTexture,
    });
    // eslint-disable-next-line no-param-reassign
    renderHThis.P2XNeddHideMesh = [...renderHThis.P2XNeddHideMesh];
    l3TopPanelArr.forEach((item) => {
        renderHThis.topPanelMesh.push(item.mesh);
        renderHThis.topPanelObjs.push(item);
        renderHThis.P2XNeddHideMesh.push(item.mesh);
        renderHThis.addMesh(item.mesh);
    });
}
// eslint-disable-next-line max-statements
function renderSkirtingBoardUtils(renderHThis) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3;
    const skirtingBoardTexture = (_d = (_c = (_b = (_a = renderHThis === null || renderHThis === void 0 ? void 0 : renderHThis.templateJson) === null || _a === void 0 ? void 0 : _a.bottom) === null || _b === void 0 ? void 0 : _b.coverPlate) === null || _c === void 0 ? void 0 : _c.componentBasic) === null || _d === void 0 ? void 0 : _d.modelUrl;
    const lastFrame = (_e = renderHThis.templateJson.bottom.length1) === null || _e === void 0 ? void 0 : _e.frames[renderHThis.templateJson.bottom.length1.frames.length - 1];
    // 二字型特殊处理 顶部只有高柜 底部没有柜体只有补板的情况
    const firstTopLengthXFrame = (_h = (_g = (_f = renderHThis.templateJson) === null || _f === void 0 ? void 0 : _f.top) === null || _g === void 0 ? void 0 : _g.length1) === null || _h === void 0 ? void 0 : _h.frames[0];
    const firstTopLengthP2XFrame = (_l = (_k = (_j = renderHThis.templateJson) === null || _j === void 0 ? void 0 : _j.top) === null || _k === void 0 ? void 0 : _k.length3) === null || _l === void 0 ? void 0 : _l.frames[0];
    const checkLengthXPosTopNoFrames = LengthX.checkTopNoFrames(renderHThis.templateJson, BASICTYPE_ENUM.top);
    const checkLengthP2XPosTopNoFrames = LengthP2X.checkTopNoFrames(renderHThis.templateJson, BASICTYPE_ENUM.top);
    const mesh = renderHThis.scene.getMeshByName(((_m = lastFrame === null || lastFrame === void 0 ? void 0 : lastFrame.componentBasic) === null || _m === void 0 ? void 0 : _m.id) || ((_o = firstTopLengthXFrame === null || firstTopLengthXFrame === void 0 ? void 0 : firstTopLengthXFrame.componentBasic) === null || _o === void 0 ? void 0 : _o.id));
    // if (!mesh) { return; }
    const doorDepth = 0;
    const tempSkirtingBoardObjs = [];
    let highFrameData = null;
    let highFrameFrontSideLength = 0; // 顶柜组里高柜的正面边长
    let sealPlateSizeX = 0; // 底柜和高柜间填补空隙的补板长
    let highFrameSkirtingBoard = [];
    // 最后一个柜体如果是冰箱不需要踢脚线
    if (!(((_r = (_q = (_p = renderHThis.templateJson) === null || _p === void 0 ? void 0 : _p.bottom) === null || _q === void 0 ? void 0 : _q.length1) === null || _r === void 0 ? void 0 : _r.frames.length) === 0 && renderHThis.refrigeraror)) {
        // 检查顶柜里是否有高柜
        if (checkHasHightFrameByPosition(renderHThis.templateJson, BASICTYPE_ENUM.top, LengthType.Length1)) {
            highFrameData = renderHThis.getHighFrameGroupPositionAndSize(BASICTYPE_ENUM.top, LengthType.Length1);
            highFrameFrontSideLength = (_s = highFrameData === null || highFrameData === void 0 ? void 0 : highFrameData.size) === null || _s === void 0 ? void 0 : _s.x;
            if (renderHThis.isSealPlateBeforeTopHightFrame(LengthType.Length1, true)) {
                // 当顶柜有高柜，底柜和高柜之间需要补板填补空隙(比如底柜240顶柜307)，正面踢脚板长度延伸，右面位置移动到高柜右边
                sealPlateSizeX = renderHThis.getSealPlateSize(BASICTYPE_ENUM.bottom, LengthType.Length1, AXES_ENUM.x);
            }
            else if (renderHThis.checkTopHightFrameIsSeparated(LengthType.Length1)) {
                // I型Length1边至少有两个柜体，不分离的情况下如果有补板只会放在第一个柜子后面sealPlateSizeX不需要作为延伸尺寸，比如底柜160顶柜220
                // 底柜和顶柜高柜分离
                // 这里处理：底柜和高柜之间不需要补板填补空隙，此时空隙较大，高柜左前右需要新建三块踢脚板
                highFrameSkirtingBoard = renderHThis.renderTopHighFrameSkirtingBoardLength1(highFrameData, skirtingBoardTexture);
                highFrameFrontSideLength = 0; // 原先的踢脚板长度不需要延伸
                sealPlateSizeX = renderHThis.getSealPlateSizeOnlyOneFrame(BASICTYPE_ENUM.bottom, LengthType.Length1, AXES_ENUM.x);
            }
            else {
                // 此时底柜和高柜之间能连接在一起，如果L1边只有一个柜子，有补板的话会放在高柜前面，sealPlateSizeX需要作为踢脚板延伸长度
                sealPlateSizeX = renderHThis.getSealPlateSizeOnlyOneFrame(BASICTYPE_ENUM.bottom, LengthType.Length1, AXES_ENUM.x);
            }
        }
        else {
            // 顶柜没有高柜，获取底柜X轴补板尺寸，如果补板在柜子中间，该值为0
            sealPlateSizeX = renderHThis.getSealPlateSizeOnlyOneFrame(BASICTYPE_ENUM.bottom, LengthType.Length1, AXES_ENUM.x);
        }
        if (sealPlateSizeX === 0 && renderHThis.isSealPlateBeforeTopRefrigeraror(LengthType.Length1)) {
            // 当顶柜没有高柜但有冰箱，底柜和冰箱之间需要补板填补空隙(比如底柜240顶柜307)，正面踢脚板长度延伸，右面位置移动到高柜右边
            sealPlateSizeX = renderHThis.getSealPlateSize(BASICTYPE_ENUM.bottom, LengthType.Length1, AXES_ENUM.x);
        }
        const bounds = mesh.getHierarchyBoundingVectors();
        // LengthP2X顶柜两(一个)高柜 , 底部无高柜，减去多余的一个高柜踢脚板长度
        if (checkLengthXPosTopNoFrames && !lastFrame) {
            highFrameFrontSideLength += bounds.min.x;
        }
        // L1正面的踢脚板
        const position1 = {
            // 将高柜正面宽和补板宽计入正面的踢脚板X坐标
            x: bounds.min.x / 2 - highFrameFrontSideLength / 2 - sealPlateSizeX / 2,
            y: SKIRTINGBOARDCONFIG.HEIGHT / 2,
            z: FRAMEDEPTH.BOTTOM - SKIRTINGBOARDCONFIG.DEPTH / 2 - doorDepth,
        };
        const size1 = {
            // 将高柜正面宽和补板宽计入正面的踢脚板width
            width: Math.abs(bounds.min.x) + highFrameFrontSideLength + sealPlateSizeX,
            height: SKIRTINGBOARDCONFIG.HEIGHT,
            depth: SKIRTINGBOARDCONFIG.DEPTH,
        };
        const skirtingBoard1 = new SkirtingBoard(renderHThis.scene, position1, size1);
        skirtingBoard1.createSkirtingBoard(skirtingBoardTexture);
        skirtingBoard1.shadowInfo = {
            width: size1.width,
            lengthType: LengthType.Length1,
            type: 'H',
        };
        renderHThis.skirtingBoard.push(skirtingBoard1);
        // L1右面的踢脚板
        const position2 = {
            // 将高柜正面宽和补板宽计入右面的踢脚板X坐标，只需移动位置尺寸不变
            x: bounds.min.x - SKIRTINGBOARDCONFIG.DEPTH / 2 - highFrameFrontSideLength - sealPlateSizeX,
            y: SKIRTINGBOARDCONFIG.HEIGHT / 2,
            z: FRAMEDEPTH.BOTTOM / 2,
        };
        const size2 = {
            width: SKIRTINGBOARDCONFIG.DEPTH,
            height: SKIRTINGBOARDCONFIG.HEIGHT,
            depth: FRAMEDEPTH.BOTTOM - doorDepth,
        };
        const skirtingBoard2 = new SkirtingBoard(renderHThis.scene, position2, size2);
        skirtingBoard2.createSkirtingBoard(skirtingBoardTexture);
        renderHThis.skirtingBoard.push(skirtingBoard2);
        // L1左面的踢脚板
        const position3 = {
            x: -SKIRTINGBOARDCONFIG.DEPTH / 2,
            y: SKIRTINGBOARDCONFIG.HEIGHT / 2,
            z: FRAMEDEPTH.BOTTOM / 2,
        };
        const size3 = {
            width: SKIRTINGBOARDCONFIG.DEPTH,
            height: SKIRTINGBOARDCONFIG.HEIGHT,
            depth: FRAMEDEPTH.BOTTOM - doorDepth,
        };
        const skirtingBoard3 = new SkirtingBoard(renderHThis.scene, position3, size3);
        skirtingBoard3.createSkirtingBoard(skirtingBoardTexture);
        renderHThis.skirtingBoard.push(skirtingBoard3);
        tempSkirtingBoardObjs.push(skirtingBoard1, skirtingBoard2, skirtingBoard3);
    }
    const tempSkirtingBoardObjsP2X = [];
    let highFrameData2 = null;
    let highFrameFrontSideLength2 = 0; // 顶柜组里高柜的正面边长
    let sealPlateSizePX = 0; // 底柜和高柜间的补板长
    let highFrameSkirtingBoard2 = [];
    if (!(((_v = (_u = (_t = renderHThis.templateJson) === null || _t === void 0 ? void 0 : _t.bottom) === null || _u === void 0 ? void 0 : _u.length3) === null || _v === void 0 ? void 0 : _v.frames.length) === 0 && renderHThis.refrigeraror)) {
        const lastFrame2 = (_w = renderHThis.templateJson.bottom.length3) === null || _w === void 0 ? void 0 : _w.frames[renderHThis.templateJson.bottom.length3.frames.length - 1];
        const mesh2 = renderHThis.scene.getMeshByName(((_x = lastFrame2 === null || lastFrame2 === void 0 ? void 0 : lastFrame2.componentBasic) === null || _x === void 0 ? void 0 : _x.id)
            || ((_y = firstTopLengthP2XFrame === null || firstTopLengthP2XFrame === void 0 ? void 0 : firstTopLengthP2XFrame.componentBasic) === null || _y === void 0 ? void 0 : _y.id));
        const bounds2 = mesh2.getHierarchyBoundingVectors();
        const meshSize2 = new MeshManage(mesh2).getModelSize();
        meshSize2.z = FRAMEDEPTH.BOTTOM - doorDepth;
        const mesh2Position = mesh2.position;
        // // 检查顶柜里是否有高柜 处理Length1边
        if (checkHasHightFrameByPosition(renderHThis.templateJson, BASICTYPE_ENUM.top, LengthType.Length3)) {
            highFrameData2 = renderHThis.getHighFrameGroupPositionAndSize(BASICTYPE_ENUM.top, LengthType.Length3);
            highFrameFrontSideLength2 = (_z = highFrameData2 === null || highFrameData2 === void 0 ? void 0 : highFrameData2.size) === null || _z === void 0 ? void 0 : _z.x;
            if (renderHThis.isSealPlateBeforeTopHightFrame(LengthType.Length3, true)) {
                // 当顶柜有高柜，底柜和高柜之间需要补板填补空隙(比如L1边底柜99顶柜167)，L1正面踢脚板长度延伸，右面位置移动到高柜右边
                sealPlateSizePX = renderHThis.getSealPlateSize(BASICTYPE_ENUM.bottom, LengthType.Length3, AXES_ENUM.x);
            }
            else if (renderHThis.checkTopHightFrameIsSeparated(LengthType.Length3)) {
                // 底柜和顶柜高柜分离
                // 这里处理：底柜和高柜之间不需要补板填补空隙，此时空隙较大，高柜左前右需要新建三块踢脚板
                highFrameSkirtingBoard2 = renderHThis.renderTopHighFrameSkirtingBoardLength1(highFrameData2, skirtingBoardTexture, LengthType.Length3);
                highFrameFrontSideLength2 = 0; // 原先的踢脚板长度不需要延伸
                sealPlateSizePX = renderHThis.getSealPlateSizeOnlyOneFrame(BASICTYPE_ENUM.bottom, LengthType.Length3, AXES_ENUM.x);
            }
            else {
                const hTypeLength3Rlength = (_0 = renderHThis.templateJson.bottom.length3) === null || _0 === void 0 ? void 0 : _0.rlength;
                if (((_1 = renderHThis.templateJson.bottom.length3) === null || _1 === void 0 ? void 0 : _1.frames.length) === 1 && hTypeLength3Rlength > 0) {
                    sealPlateSizePX = renderHThis.getSealPlateSize(BASICTYPE_ENUM.bottom, LengthType.Length3, AXES_ENUM.x);
                }
            }
        }
        else {
            const hTypeLength3Rlength = (_2 = renderHThis.templateJson.bottom.length3) === null || _2 === void 0 ? void 0 : _2.rlength;
            if (((_3 = renderHThis.templateJson.bottom.length3) === null || _3 === void 0 ? void 0 : _3.frames.length) === 1 && hTypeLength3Rlength > 0) {
                sealPlateSizePX = renderHThis.getSealPlateSize(BASICTYPE_ENUM.bottom, LengthType.Length3, AXES_ENUM.x);
            }
        }
        if (sealPlateSizePX === 0 && renderHThis.isSealPlateBeforeTopRefrigeraror(LengthType.Length3)) {
            // 当顶柜没有高柜但有冰箱，底柜和冰箱之间需要补板填补空隙(比如底柜240顶柜307)，正面踢脚板长度延伸，右面位置移动到高柜右边
            sealPlateSizePX = renderHThis.getSealPlateSize(BASICTYPE_ENUM.bottom, LengthType.Length3, AXES_ENUM.x);
        }
        // LengthP2X顶柜两（一个）高柜 , 底部无高柜，减去多余的一个高柜踢脚板长度
        if (checkLengthP2XPosTopNoFrames && !lastFrame2) {
            highFrameFrontSideLength2 += bounds2.min.x + sealPlateSizePX;
        }
        // L3正面的踢脚板
        const position4 = {
            // 把补板和顶柜高柜宽度计入踢脚板平行X坐标
            x: bounds2.min.x / 2 - sealPlateSizePX / 2 - highFrameFrontSideLength2 / 2,
            y: SKIRTINGBOARDCONFIG.HEIGHT / 2,
            z: mesh2Position.z - meshSize2.z / 2 + SKIRTINGBOARDCONFIG.DEPTH / 2,
        };
        const size4 = {
            // 把补板和顶柜高柜宽度计入踢脚板平行X尺寸
            // width: Math.abs(bounds2.min.x),
            width: Math.abs(bounds2.min.x) + sealPlateSizePX + highFrameFrontSideLength2,
            height: SKIRTINGBOARDCONFIG.HEIGHT,
            depth: SKIRTINGBOARDCONFIG.DEPTH,
        };
        const skirtingBoard4 = new SkirtingBoard(renderHThis.scene, position4, size4);
        skirtingBoard4.createSkirtingBoard(skirtingBoardTexture);
        skirtingBoard4.shadowInfo = {
            width: size4.width,
            lengthType: LengthType.Length3,
            type: 'H',
        };
        renderHThis.skirtingBoard.push(skirtingBoard4);
        // L3左面的踢脚板
        const position5 = {
            // 把补板和顶柜高柜宽度计入踢脚板平行X坐标，L3左面只需移动位置尺寸不变
            x: bounds2.min.x - SKIRTINGBOARDCONFIG.DEPTH / 2 - sealPlateSizePX - highFrameFrontSideLength2,
            y: SKIRTINGBOARDCONFIG.HEIGHT / 2,
            z: mesh2Position.z,
        };
        const size5 = { width: SKIRTINGBOARDCONFIG.DEPTH, height: SKIRTINGBOARDCONFIG.HEIGHT, depth: meshSize2.z };
        const skirtingBoard5 = new SkirtingBoard(renderHThis.scene, position5, size5);
        skirtingBoard5.createSkirtingBoard(skirtingBoardTexture);
        renderHThis.skirtingBoard.push(skirtingBoard5);
        // L3右面的踢脚板
        const position6 = {
            x: -SKIRTINGBOARDCONFIG.DEPTH / 2,
            y: SKIRTINGBOARDCONFIG.HEIGHT / 2,
            z: mesh2Position.z,
        };
        const size6 = {
            width: SKIRTINGBOARDCONFIG.DEPTH,
            height: SKIRTINGBOARDCONFIG.HEIGHT,
            depth: FRAMEDEPTH.BOTTOM - doorDepth,
        };
        const skirtingBoard6 = new SkirtingBoard(renderHThis.scene, position6, size6);
        skirtingBoard6.createSkirtingBoard(skirtingBoardTexture);
        renderHThis.skirtingBoard.push(skirtingBoard6);
        tempSkirtingBoardObjsP2X.push(skirtingBoard4, skirtingBoard5, skirtingBoard6);
    }
    renderHThis.skirtingBoard.forEach((e) => { renderHThis.addMesh(e.mesh); });
    // renderHThis.skirtingBoardObjs = [
    //   skirtingBoard1, skirtingBoard2, skirtingBoard3, skirtingBoard4, skirtingBoard5, skirtingBoard6,
    //   ...highFrameSkirtingBoard, ...highFrameSkirtingBoard2];
    // eslint-disable-next-line no-param-reassign
    renderHThis.skirtingBoardObjs = [
        ...tempSkirtingBoardObjs, ...tempSkirtingBoardObjsP2X, ...highFrameSkirtingBoard, ...highFrameSkirtingBoard2
    ];
    const highFrameSkirtingBoardMeshArr = [];
    highFrameSkirtingBoard.forEach((item) => {
        if (item) {
            highFrameSkirtingBoardMeshArr.push(item.mesh);
        }
    });
    const highFrameSkirtingBoard3MeshArr = [];
    highFrameSkirtingBoard2.forEach((item) => {
        if (item) {
            highFrameSkirtingBoard3MeshArr.push(item.mesh);
        }
    });
    // renderHThis.XNeddHideMesh = [...renderHThis.XNeddHideMesh, skirtingBoard1.mesh,
    //   skirtingBoard2.mesh, skirtingBoard3.mesh, ...highFrameSkirtingBoardMeshArr];
    // renderHThis.P2XNeddHideMesh = [...renderHThis.P2XNeddHideMesh, skirtingBoard4.mesh,
    //   skirtingBoard5.mesh, skirtingBoard6.mesh, ...highFrameSkirtingBoard3MeshArr];
    // eslint-disable-next-line no-param-reassign
    renderHThis.XNeddHideMesh = [...renderHThis.XNeddHideMesh];
    if (tempSkirtingBoardObjs[0] && tempSkirtingBoardObjs[0].mesh) {
        renderHThis.XNeddHideMesh.push(tempSkirtingBoardObjs[0].mesh);
    }
    if (tempSkirtingBoardObjs[1] && tempSkirtingBoardObjs[1].mesh) {
        renderHThis.XNeddHideMesh.push(tempSkirtingBoardObjs[1].mesh);
    }
    if (tempSkirtingBoardObjs[2] && tempSkirtingBoardObjs[2].mesh) {
        renderHThis.XNeddHideMesh.push(tempSkirtingBoardObjs[2].mesh);
    }
    renderHThis.XNeddHideMesh.push(...highFrameSkirtingBoardMeshArr);
    // eslint-disable-next-line no-param-reassign
    renderHThis.P2XNeddHideMesh = [...renderHThis.P2XNeddHideMesh];
    if (tempSkirtingBoardObjsP2X[0] && tempSkirtingBoardObjsP2X[0].mesh) {
        renderHThis.P2XNeddHideMesh.push(tempSkirtingBoardObjsP2X[0].mesh);
    }
    if (tempSkirtingBoardObjsP2X[1] && tempSkirtingBoardObjsP2X[1].mesh) {
        renderHThis.P2XNeddHideMesh.push(tempSkirtingBoardObjsP2X[1].mesh);
    }
    if (tempSkirtingBoardObjsP2X[2] && tempSkirtingBoardObjsP2X[2].mesh) {
        renderHThis.P2XNeddHideMesh.push(tempSkirtingBoardObjsP2X[2].mesh);
    }
    renderHThis.P2XNeddHideMesh.push(...highFrameSkirtingBoard3MeshArr);
}
export { renderTopPanelUtils, renderSkirtingBoardUtils, };
